
import request from '@/utils/request'

//장바구니 목록 조회
export function getCartItemList (data) { 
  return request({
    url: '/ggoods/cartItemList',
    method: 'post',
    headers: { 'Content-Type': 'application/json'},
    data
  })
}
//장바구니 삭제
export function deleteCart (data) { 
  return request({
    url: '/ggoods/deleteCart',
    method: 'post',
    headers: { 'Content-Type': 'application/json'},
    data
  })
}
//임시저장 목록 조회
export function getTempOrderList (data) { 
  return request({
    url: '/order/getTempOrderList',
    method: 'post',
    headers: { 'Content-Type': 'application/json'},
    data
  })
}
//임시저장 삭제
export function deleteOrderTemp (data) { 
  return request({
    url: '/order/deleteOrderTemp',
    method: 'post',
    headers: { 'Content-Type': 'application/json'},
    data
  })
}






